import { CIcon } from '~/icons/types'
export const ciArrowRight: CIcon = {
  name: 'arrow-right',
  type: 'solid',
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M21.4 11.4c-.1-.2-.2-.4-.3-.5l-6.7-7c-.6-.6-1.5-.6-2.1 0-.6.6-.6 1.5 0 2.1l4.3 4.5H4c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h12.5L12.2 18c-.6.6-.6 1.5 0 2.1.3.3.7.4 1 .4.4 0 .8-.2 1.1-.5l6.7-7c.1-.1.2-.3.3-.4v-.1c.1-.2.1-.3.1-.5.1-.2.1-.4 0-.6Z',
      fill: 'currentColor'
    }
  ]
}
